import PropTypes from 'prop-types';

import useTranslations from '@/i18n/useTranslations';
import ConfirmationDialog from '@/shared-components/popups/components/ConfirmationDialog';

export default function ArtGameDeleteConfirmation({ open, onCancel, onConfirm, isDeleting }) {
  const t = useTranslations('common.newspaper.art_games.delete_dialog');
  const handleCancel = () => {
    if (!isDeleting) {
      onCancel();
    }
  };

  return (
    <ConfirmationDialog
      open={open}
      title={t('title')}
      dialogText={t('description')}
      onClose={handleCancel}
      onConfirm={onConfirm}
      confirmButtonText={t('confirm')}
      loading={isDeleting}
      showCancelButton={false}
      opacity
    />
  );
}

ArtGameDeleteConfirmation.propTypes = {
  isDeleting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
